module.exports = __webpack_public_path__ + "static/img/14.5ab6b57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/14.png
// module id = 21Lh
// module chunks = 0